if (!customElements.get('vh-home-bestsellers')) {
  customElements.define('vh-home-bestsellers', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.querySelector('[data-tabs]')?.setAttribute('role', 'tablist');
      this.tabs.forEach(tab => { tab.setAttribute('role', 'tab'); tab.removeAttribute('aria-current'); });
      this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      this.show(0, false);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-tab]');
        if (!tab || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.show(Number(tab.dataset.tab), false);
      }, { signal });
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-tab]');
        if (!tab) return;
        let index = Number(tab.dataset.tab);
        if (event.key === 'ArrowRight') index++;
        else if (event.key === 'ArrowLeft') index--;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.show((index + this.tabs.length) % this.tabs.length, true);
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index, false);
      }, { signal });
    }
    show(index, focus) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      const viewAll = this.querySelector('[data-view-all]');
      if (viewAll && this.panels[index]) viewAll.href = this.panels[index].dataset.collectionUrl;
      if (focus) this.tabs[index]?.focus({ preventScroll: true });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('vh-home-product-card')) {
  customElements.define('vh-home-product-card', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener('click', event => {
        const swatch = event.target.closest('[data-swatch]');
        if (!swatch || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.querySelectorAll('[data-swatch]').forEach(item => {
          const active = item === swatch;
          item.classList.toggle('is-selected', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
        this.querySelectorAll('[data-product-link]').forEach(link => { link.href = swatch.href; });
        const image = this.querySelector('.vh-home-product__image');
        if (image && swatch.dataset.image) {
          image.srcset = swatch.dataset.srcset;
          image.src = swatch.dataset.image;
        }
        this.querySelector('[data-price]').textContent = swatch.dataset.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = swatch.dataset.compare;
        compare.hidden = !swatch.dataset.compare;
        const input = this.querySelector('input[name="id"]');
        if (input) input.value = swatch.dataset.variantId;
        const add = this.querySelector('button[name="add"]');
        if (add) add.disabled = swatch.dataset.available !== 'true';
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
